import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchLostFound,
  fetchLostFoundItem,
  createLostFound,
  updateLostFound,
  type ListLostFoundQuery,
  type CreateLostFoundPayload,
  type UpdateLostFoundPayload,
} from '@/services/api/lostFound.api';

export function useLostFound(query: ListLostFoundQuery, enabled = true) {
  return useQuery({
    queryKey: ['lost-found', query],
    queryFn: () => fetchLostFound(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useLostFoundItem(id: string | null) {
  return useQuery({
    queryKey: ['lost-found', id],
    queryFn: () => fetchLostFoundItem(id as string),
    staleTime: 30_000,
    enabled: id !== null,
  });
}

export function useCreateLostFound() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateLostFoundPayload) => createLostFound(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['lost-found'] });
    },
  });
}

export function useUpdateLostFound() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateLostFoundPayload }) =>
      updateLostFound(id, payload),
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({ queryKey: ['lost-found', id] });
      void queryClient.invalidateQueries({ queryKey: ['lost-found'] });
    },
  });
}
